"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(handlers) {
    var onPointClick = handlers.onPointClick, onPointMouseEnter = handlers.onPointMouseEnter, onPointMouseLeave = handlers.onPointMouseLeave;
    var events = __assign(__assign(__assign({}, (onPointClick && {
        click: function (event) {
            onPointClick(event.point);
        }
    })), (onPointMouseEnter && {
        mouseOut: function (event) {
            onPointMouseEnter(event.point);
        }
    })), (onPointMouseLeave && {
        mouseOver: function (event) {
            onPointMouseLeave(event.point);
        }
    }));
    return {
        events: events
    };
}
exports.default = default_1;
//# sourceMappingURL=bindPointEventHandlers.js.map